import { render } from "./StatisticsCenter.vue?vue&type=template&id=34f201af&scoped=true"
import script from "./StatisticsCenter.vue?vue&type=script&lang=js"
export * from "./StatisticsCenter.vue?vue&type=script&lang=js"

import "./StatisticsCenter.vue?vue&type=style&index=0&id=34f201af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f201af"]])

export default __exports__